export default {
  getDate: (dt, d, m, y) => {
    if (d) {
      dt.setDate(dt.getDate() + d);
    }
    if (m) {
      dt.setMonth(dt.getMonth() + m);
    }
    if (y) {
      dt.setFullYear(dt.getFullYear() + y);
    }
    const nextDate = new Date(dt);
    let yyyy = nextDate.getFullYear();
    while (yyyy.toString().length < 4) {
      yyyy = `0${yyyy}`;
    }
    let dd = nextDate.getDate();
    if (dd.toString().length < 2) {
      dd = `0${dd}`;
    }
    let mm = nextDate.getMonth() + 1;
    if (mm.toString().length < 2) {
      mm = `0${mm}`;
    }
    return `${yyyy}-${mm}-${dd}`;
  },
  getToday: (day = 0, month = 0, year = 0) => {
    const d = new Date();
    if (day) {
      d.setDate(d.getDate() + day);
    }
    if (month) {
      d.setMonth(d.getMonth() + month);
    }
    if (year) {
      d.setFullYear(d.getFullYear() + year);
    }
    let yyyy = d.getFullYear();
    while (yyyy.toString().length < 4) {
      yyyy = `0${yyyy}`;
    }
    let dd = d.getDate();
    if (dd.toString().length < 2) {
      dd = `0${dd}`;
    }
    let mm = d.getMonth() + 1;
    if (mm.toString().length < 2) {
      mm = `0${mm}`;
    }
    return `${yyyy}-${mm}-${dd}`;
  },
};
